export const orbitDetails = {
  heading: "Add orbit",
  orbit: "orbit name",
  user: "status",
  description: "orbit description",
};


export const orbitConfigDetails= {
  heading:'Add orbit',
  fieldDetails:[
    {
      label:'orbit name',
      name:'orb_name',
      type:'text',
      placeHolder:'orbitName'
 
    },
    {
      label:'orbit description',
      name:'orb_description',
      type:'text',
      placeHolder:'description'
    },
  ],
}

export const statusOption = [
  {lable: 'active' ,
    id:1
  },
  { lable: 'inactive' ,
    id:2

  },
];
